import { observer } from 'mobx-react';
import Button from '~/components/commonUi/Button/Button';
import Fieldset from '~/components/commonUi/Fieldset';
import { posterGroups } from '~/consts/poster';
import { PosterGroup } from '~/definitions/poster';
import { getStore } from '~/mobx/AppStore';

interface RegionPreviewPureProps {
    regionTitle?: string;
    onPreviewBallot: () => void;
    onExportElectionData: () => void;
    onCreatePdfBallot: (showAll: boolean) => void;
    onCreatePdfPoster: (candidates: PosterGroup['candidates'], size: string) => void;
}

const RegionPreviewPure = ({
    regionTitle,
    onPreviewBallot,
    onExportElectionData,
    onCreatePdfBallot,
    onCreatePdfPoster,
}: RegionPreviewPureProps) => {
    const pClassName = 'mt-0 mb-[16px]';
    const btnClassName = 'text-[11.48px] w-full';

    return (
        <Fieldset title={regionTitle}>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {/* Ballot */}
                <div className="ballot">
                    <Fieldset>
                        <>
                            <p className={pClassName}>
                                <Button
                                    extendedClassName={btnClassName}
                                    btnText={'Vis WEB stemmeseddel'}
                                    testId={'preview-all-ballot-button'}
                                    onClick={onPreviewBallot}
                                />
                            </p>
                            <p className={pClassName}>
                                <Button
                                    extendedClassName={btnClassName}
                                    btnText={'Eksporter valgdata...'}
                                    testId={'export-election-data-button'}
                                    onClick={onExportElectionData}
                                />
                            </p>
                            <p className={pClassName}>
                                <Button
                                    extendedClassName={`${btnClassName} hidden`}
                                    btnText={'Lag PDF stemmeseddel'}
                                    testId={'create-pdf-ballot-button'}
                                    onClick={() => onCreatePdfBallot(false)}
                                />
                            </p>
                        </>
                    </Fieldset>
                </div>
                {/* Candidate poster */}
                {posterGroups.map(({ candidates, posters }) => (
                    <div key={`candidate-posters-${candidates}`} className="candidate-posters">
                        <Fieldset title={`Lag kandidatplakater (${candidates})`} key={candidates}>
                            <>
                                {posters.map(({ size, text }, idx) => (
                                    <p key={`${candidates}-${size}-${idx}`} className={pClassName}>
                                        <Button
                                            extendedClassName={btnClassName}
                                            btnText={text}
                                            testId={`create-pdf-poster-${size}-${candidates}`}
                                            onClick={() => onCreatePdfPoster(candidates, size)}
                                        />
                                    </p>
                                ))}
                            </>
                        </Fieldset>
                    </div>
                ))}
            </div>
        </Fieldset>
    );
};

const RegionPreviewWithStore = () => {
    const { regionPreviewStore, electionMenuStore } = getStore();

    const handleExportElectionData = () => {
        // eslint-disable-next-line no-console
        console.log('Eksporter valgdata... clicked ');
    };

    const handleCreatePdfBallot = (showAll: boolean) => {
        // eslint-disable-next-line no-console
        console.log('Lag PDF stemmeseddel clicked | showAll =', showAll);
    };

    const handleCreatePdfPoster = async (candidates: PosterGroup['candidates'], size: string) => {
        await regionPreviewStore.createRegionPreviewPoster(candidates, size);
    };

    return (
        <RegionPreviewPure
            regionTitle={`${electionMenuStore.selectedElectionMenu?.text} - Forhåndsvis`}
            onPreviewBallot={regionPreviewStore.handlePreviewBallot}
            onExportElectionData={handleExportElectionData}
            onCreatePdfBallot={handleCreatePdfBallot}
            onCreatePdfPoster={handleCreatePdfPoster}
        />
    );
};

export default observer(RegionPreviewWithStore);
